import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UserNotificationModel } from '@rma/dashboard/notification-bell/private/api-user-notifications';
import { NotificationRouteData } from '@rma/dashboard/notification-bell/private/util-notification-content';
import { NotificationItemGenericComponent } from '../ui-notification-item-generic/notification-item-generic.component';
import { NotificationItemSystemComponent } from '../ui-notification-item-system/notification-item-system.component';

@Component({
  selector: 'rma-notification-item',
  templateUrl: 'notification-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NotificationItemGenericComponent, NotificationItemSystemComponent],
})
export class NotificationItemComponent {
  @Input() public notification: UserNotificationModel;
  @Input() public containerClass: string;
  @Input() public showStatusIcon = true;

  @Output() public navigate = new EventEmitter<NotificationRouteData>();
}
